import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const SwitchContainer = styled.div`
  width: ${({ width }) => width};
`;

const SwitchLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  width: 40px;
  height: 24px;
  border-radius: 100px;
  position: relative;
  transition: background-color 0.01s;
  background-color: ${select('middleGray')};
  ${({ checked }) =>
    checked &&
    css`
       {
        background-color: ${getColor('primary')};
      }
    `}
`;

const SwitchButton = styled.div`
  content: '';
  position: absolute;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 45px;
  transition: 0.02s;
  background: ${select('white')};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${({ checked }) =>
    checked &&
    css`
      left: calc(100% - 2px);
      transform: translateX(-100%);
    `}
`;

export { SwitchLabel, SwitchButton, SwitchContainer };
